import axios from 'axios';
import {GET_ERRORS, CLEAR_CURRENT_PROFILE} from "./types";

export const updatePassword = userData => dispatch => {
  axios
    .post(`${process.env.REACT_APP_API_URL_BASE}/api/user/updatePassword`, userData)
    .then( res =>{
      if (res.data.error) {
        dispatch({
            type: GET_ERRORS,
            payload: res.data.error
          });
      } else {
        //log user out
        localStorage.clear();
        // Set current user to {} which will also set isAuthenticated to false
        dispatch({
          type: CLEAR_CURRENT_PROFILE,
          payload: null
        });
      }
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      })
    });
}



// WEBPACK FOOTER //
// ./src/actions/accountActions.jsx